/* Import Polyfills */
import polyfills from './util/polyfills';

/* Import Loader */
// import loader from './components/loader';

/* Import Highway JS Setup */
import HighwaySetup from './highway/setup';

/* Import Renderers */
import defaultRenderer from './highway/renderers/default';
import home from './highway/renderers/home';
import careers from './highway/renderers/careers';
import about from './highway/renderers/about';
import sustainability from './highway/renderers/sustainability';
import gtac from './highway/renderers/gtac';
import singleMediaCenter from './highway/renderers/singleSodeciaMediacenter';
import jobs from './highway/renderers/jobs';
import job from './highway/renderers/job';
import locations from './highway/renderers/locations';
import capabilities from './highway/renderers/capabilities';
import products from './highway/renderers/products';
import selfApplication from './highway/renderers/selfApplication';
import mobileMenu from './components/mobileMenu';

const renderers = {
	page: defaultRenderer,
	404: defaultRenderer,
	home: home,
	template_careers: careers,
	template_aboutus: about,
	template_sustainability: sustainability,
	template_gtac: gtac,
	template_legal: defaultRenderer,
	archive_sodecia_mediacenter: defaultRenderer,
	taxonomy_sodecia_mediacenter_category: defaultRenderer,
	single_sodecia_mediacenter: singleMediaCenter,
	archive_sodecia_job: jobs,
	single_sodecia_job: job,
	template_selfapplication: selfApplication,
	index: defaultRenderer,
	single_post: defaultRenderer,
	archive_sodecia_location: locations,
	template_capabilities: capabilities,
	archive_sodecia_product: products,
};

/**
 * ---------------------------------------------------------------------------
 * Initialize
 * ---------------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', () => {
	// loader();
	polyfills();
	HighwaySetup(renderers);
	mobileMenu();
});



// WEBPACK FOOTER //
// ./scripts/main.js